<template>
	<div>
		<PageHeaderLayout :isBack="true">
			<div class="main-page-content">
				<el-row class="table-search">
					<el-form :inline="true" :model="searchCondition" class="demo-form-inline">
						<el-form-item v-for="item in searchList" :key="item.props" :label="item.label">
							<el-input
								v-if="item.type === 'input'"
								v-model="searchCondition[item.props]"
								:placeholder="'请输入' + item.label"
								clearable
							></el-input>
							<el-select
								v-if="item.type === 'select'"
								v-model="searchCondition[item.props]"
								:placeholder="'请选择' + item.label"
								clearable
							>
								<el-option v-for="option in item.selectData" :key="option.value" :label="option.label" :value="option.value"></el-option>
							</el-select>
							<DatePicker v-if="item.type === 'date'" @dataSearch="dataSearch(item.props, $event)" />
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="searchButton">查询</el-button>
						</el-form-item>
					</el-form>
				</el-row>
				<ApeTable
					ref="apeTable"
					:data="tableData"
					:columns="columns"
					:loading="loadingStaus"
					:pagingData="pagingData"
					@switchPaging="switchPaging"
					highlight-current-row
				>
					<el-table-column label="操作" width="100" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button type="text" size="mini" @click="showDetail(scope.row)">查看</el-button>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>

		<el-dialog title="详情" :visible.sync="detailVisible" width="600px">
			<el-form label-width="110px" class="detail-form">
				<el-form-item v-for="item in formList" :key="item.props" :label="item.label">
					<el-input :value="getDetailValue(item)" disabled></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="detailVisible = false">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import DatePicker from '@/components/DatePicker.vue'
import { search_list, tableColumns, form_list } from './config/insuranceDetail.ts'

export default {
	name: 'InsuranceDetail',
	components: {
		PageHeaderLayout,
		ApeTable,
		DatePicker
	},
	data() {
		return {
			searchCondition: {},
			searchList: search_list,
			formList: form_list,
			loadingStaus: true,
			detailVisible: false,
			detailData: {},
			tableData: [],
			pagingData: {
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			},
			columns: tableColumns
		}
	},
	methods: {
		dataSearch(prop, value) {
			this.searchCondition[prop] = value
		},
		searchButton() {
			this.initList('search')
		},
		switchPaging() {
			this.initList()
		},
		getPolicyStatusText(row) {
			if (row.status == 1) {
				return row.policy_status == 1 ? '参保中' : '已失效'
			}
			return '参保失败'
		},
		showDetail(row) {
			this.detailData = {
				...row,
				is_clock_work_text: row.is_clock_work == 1 ? '考勤打卡' : '直接投保',
				policy_status_text: this.getPolicyStatusText(row)
			}
			this.detailVisible = true
		},
		formatMoneyText(value) {
			return value === '' || value == null ? '-' : `${value} 元`
		},
		getDetailValue(item) {
			const value = this.detailData[item.props]
			if (value === '' || value == null) {
				return '-'
			}
			return item.append ? `${value} ${item.append}` : value
		},
		getSearchParams() {
			const params = { ...this.searchCondition }
			if (params.date && params.date.length) {
				params.start_time = params.date[0]
				params.end_time = params.date[1]
				delete params.date
			}
			return params
		},
		formatList(list) {
			return list.map(item => {
				return {
					...item,
					premium: item.premium != null ? item.premium / 100 : '',
					sum_insured: item.sum_insured != null ? item.sum_insured / 100 : '',
					surrender_amount: item.surrender_amount != null ? item.surrender_amount / 100 : '',
					is_clock_work_text: item.is_clock_work == 1 ? '考勤打卡' : '直接投保',
					policy_status_text: this.getPolicyStatusText(item)
				}
			})
		},
		async initList(type) {
			this.loadingStaus = true
			const pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
			if (type === 'search') {
				pagingInfo.current_page = 1
			}
			if (!this.$api.getInsList) {
				this.loadingStaus = false
				this.$message.error('请先提供保险详情列表接口')
				return
			}
			try {
				const params = {
					...this.getSearchParams(),
					...pagingInfo,
					page: pagingInfo.current_page,
					taxpayer: this.$route.query.taxpayer,
					product_plan_id: this.$route.query.product_plan_id,
					job_level: this.$route.query.job_level
				}
				delete params.current_page
				const res = await this.$api.getInsList(params)
				const list = res.items || res.data || res.list || []
				this.tableData = this.formatList(list)
				this.pagingData.total = res.total || (res.pages && res.pages.total) || 0
				this.pagingData.offset = res.offset || (res.pages && res.pages.offset) || 0
			} catch (e) {
				this.tableData = []
				this.$message.error(e.message || '获取保险详情列表失败')
			}
			this.loadingStaus = false
		}
	},
	mounted() {
		this.initList()
	}
}
</script>

<style lang="scss" scoped>
.table-search {
	margin-bottom: 16px;
}
</style>
